import { FaUsers } from "react-icons/fa6";
import { Link } from "react-router-dom";
import ProductsImg from "../../images/products/products-img.png";
import ProductsBg from "../../images/products/products-bg.png";
import Product1 from "../../images/products/product1-img.png";
import Product2 from "../../images/products/product2-img.png";
import Product3 from "../../images/products/product3-img.png";
import Product4 from "../../images/products/product4-img.png";
import Product5 from "../../images/products/product5-img.png";
import Product6 from "../../images/products/product6-img.png";
import Product7 from "../../images/products/product7-img.png";
import Product8 from "../../images/products/product8-img.png";
import Product9 from "../../images/products/product9-img.png";
import Product10 from "../../images/products/product10-img.png";
import Product11 from "../../images/products/product11-img.png";

function ProductsMain() {
  return (
    <div className="products-main">
      <img src={ProductsBg} alt="bg" className="bg-image" />
      <div className="heading">
        <img src={ProductsImg} alt="bg" />
        <h1>Our Products</h1>
        <p>
          Over the years, we've built a range of tools to solve real problems —
          tools that help teams work better, manage faster, and stay in control.
          These 11 products weren't built for show — they were built because
          someone needed them.
        </p>
      </div>
      <div className="products">
        <div className="row">
          <div className="product">
            <span className="product-icon">
              <FaUsers size={28} color="#2b6cb0" />
            </span>

            <h2>HOSTCOMAN</h2>
            <p>
              A digital platform for Licensees, Regulators, and Stakeholders to
              streamline Host Community Development Trust reporting, ensure
              transparency, and drive sustainable growth in Nigeria’s oil and
              gas host communities.
            </p>
            <div className="link">
              <Link to="/products/hostcoman">
                <p className="text">Learn more</p>
              </Link>
              <div />
            </div>
          </div>
          <div className="product">
            <img src={Product1} alt="product" className="icon" />
            <h2>BrandCollect</h2>
            <p>
              BrandCollect is a web based service that facilitates real-time
              collection of payments for ministries, departments and agencies
              (MDAs) of government.
            </p>
            <div className="link">
              <p className="text">Learn more</p>
              <div />
            </div>
          </div>
          <div className="product">
            <img src={Product2} alt="product" className="icon" />
            <h2>IVisitNG</h2>
            <p>
              IVisitNG is used for visitor registration, chip-based badge
              printing, tracking, reporting, visitors' preregistration and
              employee/contractor time and attendance management system.
            </p>
            <div className="link">
              <p className="text">Learn more</p>
              <div />
            </div>
          </div>
          <div className="product">
            <img src={Product3} alt="product" className="icon" />
            <h2>BREMS</h2>
            <p>
              Brandone revenue enhancement and monitoring system (brems). This
              is a suite of application for collection of revenue by federal,
              state and local government.
            </p>
            <div className="link">
              <p className="text">Learn more</p>
              <div />
            </div>
          </div>
          <div className="product">
            <img src={Product4} alt="product" className="icon" />
            <h2>CampusDirect</h2>
            <p>
              CampusDirect is an embodiment of various tools required for
              optimal running of Tertiary Institutions.
            </p>
            <div className="link">
              <p className="text">Learn more</p>
              <div />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="product">
            <img src={Product5} alt="product" className="icon" />
            <h2>Autolicense</h2>
            <p>
              It helps in vehicle administration, vehicle license renewal and
              generation of customized reports for all kinds of vehicles
              registered in a state.
            </p>
            <div className="link">
              <p className="text">Learn more</p>
              <div />
            </div>
          </div>
          <div className="product">
            <img src={Product6} alt="product" className="icon" />
            <h2>Brandpay</h2>
            <p>
              Brandpay is a web based solution with an efficient platform for
              managing multiple credit payments that recur periodically across
              banks
            </p>
            <div className="link">
              <p className="text">Learn more</p>
              <div />
            </div>
          </div>
          <div className="product">
            <img src={Product7} alt="product" className="icon" />
            <h2>Smartmobile</h2>
            <p>
              This is a Mobile App used to capture live data on the field and
              send to the manager or supervisor at the back office in real time.
            </p>
            <div className="link">
              <p className="text">Learn more</p>
              <div />
            </div>
          </div>
          <div className="product">
            <img src={Product8} alt="product" className="icon" />
            <h2>Dokmee</h2>
            <p>
              An Electronic Document Management software suite that enables
              companies to adopt an electronic and automated approach to
              document management across an enterprise.
            </p>
            <div className="link">
              <p className="text">Learn more</p>
              <div />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="product">
            <img src={Product9} alt="product" className="icon" />
            <h2>EProcure</h2>
            <p>
              It give your procurement team the software tools for strategic
              sourcing to drive process efficiency and cost savings throughout
              the organization.
            </p>
            <div className="link">
              <p className="text">Learn more</p>
              <div />
            </div>
          </div>
          <div className="product">
            <img src={Product10} alt="product" className="icon" />
            <h2>E-Government Suite</h2>
            <p>
              A unified Platform Business Process and Document Management
              Solutions to deliver for Government to Citizen (G2C), Government
              to Business (G2B) and Government to Government Agencies (G2G)
              processes.
            </p>
            <div className="link">
              <p className="text">Learn more</p>
              <div />
            </div>
          </div>
          <div className="product">
            <img src={Product11} alt="product" className="icon" />
            <h2>E-Budget Suite</h2>
            <p>
              A web web-based Budget & Project management system that eases
              budget planning, preparations implementation and tracking process.
            </p>
            <div className="link">
              <p className="text">Learn more</p>
              <div />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductsMain;
